import { StylovyzeIconProps } from '@innovyze/stylovyze';
import { Path } from '@innovyze/stylovyze';
import React from 'react';


const InspectionsIcon: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			fill="none"
			viewBox="0 0 25 25"
			{...props}
		>
			<g fill={color} color={color} clipPath="url(#clip0)">
				<Path
					fillRule="evenodd"
					d="M18.936 10.48V4.068H.956L.94 19.523H12.9v-1.427H2.39V10.48h16.547zM2.406 5.49h15.088v3.563H2.407V5.49zm12.22 1.798a.716.716 0 101.431 0 .716.716 0 00-1.432 0zm-1.476.716a.716.716 0 110-1.432.716.716 0 010 1.432zm-2.863-.716a.715.715 0 101.43.002.715.715 0 00-1.43-.002z"
					clipRule="evenodd"
				/>
				<Path
					d="M16.37 11.943a2.98 2.98 0 012.264 4.918l.124.124h.362l2.291 2.292-.687.687-2.292-2.291v-.363l-.123-.123a2.987 2.987 0 01-4.046-.158 2.98 2.98 0 012.107-5.086zm0 .917a2.054 2.054 0 00-2.063 2.063c0 1.145.917 2.062 2.063 2.062a2.054 2.054 0 002.062-2.063 2.054 2.054 0 00-2.062-2.062z"
				/>
			</g>
			<defs>
				<clipPath id="clip0">
					<Path
						fill={color}
						color={color}
						d="M0 0H24V24H0z"
						transform="translate(.016 .568)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default InspectionsIcon;
